import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { add, startOfMonth, startOfWeek } from "date-fns";
import React, { useEffect } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Employee from "./Employee";
import LocationView from "./LocationView";
import Main from "./Main";
import MenuView from "./MenuView";
import MenuWeek from "./MenuWeek";
import MonthView from "./MonthView";
import TodayView from "./TodayView";
import { useLocation } from "./utils/useLocation";
import WeekView from "./WeekView";

const queryClient = new QueryClient();

function App() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  useEffect(() => {
    if (params.get("preview")) {
      const newWindow = window.open(window.location.href.split("?")[0], "Preview", "resizable");
      newWindow.resizeTo(1280, 800);
      window.location.href = window.location.href.split("?")[0];
    }
  }, []);

  const today = new Date();
  const startWeek = startOfWeek(today);
  const startMonth = startOfMonth(today);
  const nextMonth = add(startMonth, {
    months: 1,
  });
  const monthAfterNext = add(startMonth, {
    months: 2,
  });
  const nextWeek = add(startWeek, {
    weeks: 1,
  });

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route path="/:community/menu/:week(week|next-week)?" element={<MenuWeek />} />
          <Route path="/:community/:wing?/month" element={<MonthView />} />
          <Route path="/:community/:wing?/month/next" element={<MonthView date={nextMonth} />} />
          <Route
            path="/:community/:wing?/month/after-next"
            element={<MonthView date={monthAfterNext} />}
          />
          <Route path="/:community/:wing?/week" element={<WeekView />} />
          <Route path="/:community/next-week" element={<WeekView date={nextWeek} />} />
          <Route path="/:community/menu" element={<MenuView />} />
          <Route path="/:community/today" element={<TodayView />} />
          <Route path="/:community/location/:wing?" element={<LocationView />} />
          <Route path="/:community/employee" element={<Employee />} />
          <Route path="/:community?/:wing?" element={<Main />} />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
